import { useState, FormEvent } from 'react';
import { Send } from 'lucide-react';
import { motion } from 'framer-motion';

const EmailSignup = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setStatus('loading');

    try {
      // Submit form data to Zapier webhook
      const formData = new FormData();
      formData.append('name', name);
      formData.append('email', email);
      formData.append('source', 'PedigreePro Website');

      await fetch('https://hooks.zapier.com/hooks/catch/19361006/ud5haay/', {
        method: 'POST',
        mode: 'no-cors',
        body: formData,
      });

      // Since we're using no-cors mode, we can't check the response
      // so we assume success
      setStatus('success');
      setName('');
      setEmail('');
    } catch (error) {
      console.error('Webhook submission error:', error);
      setStatus('error');
    }
  };

  return (
    <section className="bg-neutral-50 py-16">
      <div className="container mx-auto px-4">
        <motion.div 
          className="max-w-2xl mx-auto text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="font-sans text-3xl font-bold mb-4">Want to Learn More?</h2>
          <p className="text-neutral-600 mb-8">
            Sign up to receive more information about PedigreePro and stay updated with our latest features.
          </p>

          <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
            <div className="grid md:grid-cols-2 gap-4 mb-4">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
                required
                className="px-4 py-3 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary"
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="px-4 py-3 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary"
              />
            </div>
            <div className="flex justify-center">
              <button
                type="submit"
                disabled={status === 'loading'}
                className="btn bg-primary text-white hover:bg-primary-dark disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center gap-2"
              >
                {status === 'loading' ? 'Sending...' : 'Subscribe'}
                <Send size={18} />
              </button>
            </div>

            {status === 'success' && (
              <p className="mt-4 text-success">Thank you! We'll be in touch soon.</p>
            )}
            {status === 'error' && (
              <p className="mt-4 text-error">Something went wrong. Please try again later.</p>
            )}
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default EmailSignup;